<nav aria-label="breadcrumb" class="app-breadcrumb d-flex justify-content-between align-items-center border-top">
  <ol class="app-breadcrumb__list">
    @for (context of contexts(); track context.route) {
    @if (!$last) {
    <li class="app-breadcrumb__item">
      <a (click)="navigateTo(context.route)" class="app-breadcrumb__link">{{ translateKey() ? ((translateKey() + '.' +
        context.breadcrumb.breadcrumbName) | translate) : context.breadcrumb.breadcrumbName }}</a>
    </li>
    } @else {
    <li class="app-breadcrumb__item app-breadcrumb__item--active">
      <span class="app-breadcrumb__current">{{ translateKey() ? ((translateKey() + '.' +
        context.breadcrumb.breadcrumbName) | translate) : context.breadcrumb.breadcrumbName
        }}</span>
    </li>
    }
    }
  </ol>
  @if (contexts().length > 1) {
  <button mat-button color="primary" class="app-breadcrumb__back-button" (click)="back()">
    <mat-icon class="me-1">arrow_back</mat-icon>
    Back</button>
  }
</nav>